import vue from "vue";

const state = {
  name: "",
  isShow: false,
  isActive: false
};

const mutations = {
  OPEN_MODAL_WINDOW(state, value) {
    vue.set(state, "name", value);
    vue.set(state, "isShow", true);
  },
  CLOSE_MODAL_WINDOW(state) {
    vue.set(state, "name", "");
    vue.set(state, "isShow", false);
  },
  MODAL_WINDOW_ACTIVE_TOGGLER(state, value) {
    vue.set(state, "isActive", value);
  }
};

export default {
  state,
  mutations
};
